'use client'
import Close from "@/assets/icon/close.svg";

// TODO:Timo TODO:Matthias

import React from "react";

export function NavClose({onClick}: {onClick: () => void}) {
  return <div className="pr-safe-area-inset-right pt-safe-area-inset-top fixed top-0 right-0 z-[60] mr-2 mt-2">
    <button className="mobile-nav-button" onClick={onClick} aria-label="Schließen">
      <Close />
    </button>
  </div>
}
